import TechnicalDifficultiesPage from './TechnicalDifficulties';

export default TechnicalDifficultiesPage;
